/**
 * @description: 数字转人民币格式
 * @param {*} num 价格
 * @return {*}
 */
export function numberToMoney(num) {
  let integer = (num + '').split('.')[0] //转成字符串后的整数
  let decimal = (num + '').split('.')[1] //转成字符串后的小数数
  decimal = decimal ? '.' + decimal : ''
  let a = integer.length % 3 //模3取余
  let result = '' //最终结果
  a = a == 0 ? 0 : a == 1 ? 2 : 1 //判断添加0的个数
  for (let i = 0; i < a; i++) {
    integer = '0' + integer
  }
  for (let i = 1; i <= integer.length; i++) {
    result += integer[i - 1]
    if (i % 3 == 0 && i != integer.length) {
      result += ','
    }
  }
  return (result = result.slice(a) + decimal)
}

/**
 * @description: 价格保留小数位
 * @param {string/number} price 价格
 * @param {number} n 保留几位小数
 * @return {*}
 */
export function priceCecimal(price, n = 2) {
  if (price) {
    price = Number(price)
    return price.toFixed(n)
  } else {
    var zero = 0
    return zero.toFixed(n)
  }
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data = [], id = id, parentId = 'parentId', children = children, rootId) {
  rootId =
    rootId ||
    Math.min.apply(
      Math,
      data.map(item => {
        return item[parentId]
      })
    ) ||
    0
  //对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data))
  //循环所有项
  const treeData = cloneData.filter(father => {
    let branchArr = cloneData.filter(child => {
      //返回每一项的子级数组
      return father[id] === child[parentId]
    })
    branchArr.length > 0 && (father.children = branchArr)
    //返回第一层
    return father[parentId] === rootId
  })
  // 排序
  treeData
    .sort((a, b) => {
      return Number(a.code) - Number(b.code)
    })
    .forEach(m => {
      if (m.children && m.children.length) {
        m.children.sort((c, d) => {
          return Number(c.code) - Number(d.code)
        })
      }
    })
  return treeData !== '' ? treeData : data
}

/**
 * @description: 指定日期前/后几天
 * @param {*} date 指定日期
 * @param {number} day 距离当前几天
 * @return {string}
 */
export function getNextDate(date, day) {
  var dd = new Date(date)
  dd.setDate(dd.getDate() + day)
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
  var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
  return y + '-' + m + '-' + d
}

/**
 * @description: 获取日期格式对象
 * @param {string} strDate 字符串日期
 * @return {string}
 */
export function getObjDate(strDate) {
  var date = eval(
    'new Date(' +
    strDate
      .replace(/\d+(?=-[^-]+$)/, function (a) {
        return parseInt(a, 10) - 1
      })
      .match(/\d+/g) +
    ')'
  )
  return date
}

/**
 * @description: 返回周几
 * @param {*} date 日期
 * @return {string}
 */
export function getWeek(date) {
  let week = moment(date).day()
  switch (week) {
    case 1:
      return '周一'
    case 2:
      return '周二'
    case 3:
      return '周三'
    case 4:
      return '周四'
    case 5:
      return '周五'
    case 6:
      return '周六'
    case 0:
      return '周日'
  }
}

/**
 * @description: 相对时间
 * @param {*} time 时间
 * @return {string}
 */
export function fromNow(time = new Date()) {
  let result = null
  let oldTime = new Date(time).getTime()
  let mistiming = Math.round(new Date()) - oldTime
  let arrr = ['年', '个月', '星期', '天', '小时', '分钟', '秒']
  let arrn = [31536000, 2592000, 604800, 86400, 3600, 60, 1]
  for (let i = 6; i >= 0; i--) {
    let inm = Math.floor(mistiming / 1000 / arrn[i])
    if (inm != 0) {
      result = inm + arrr[i] + '前'
    }
  }
  return result
}
/**
 * @description: 深度克隆
 * @param {*} obj 想要被深度克隆的元素
 * @return {obj}深度克隆后的元素
 */
export function deepClone(obj) {
  // 对常见的“非”值，直接返回原来值
  if ([null, undefined, NaN, false].includes(obj)) return obj;
  if (typeof obj !== "object" && typeof obj !== 'function') {
    //原始类型直接返回
    return obj;
  }
  var o = isArray(obj) ? [] : {};
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = typeof obj[i] === "object" ? deepClone(obj[i]) : obj[i];
    }
  }
  return o;
}

/**
 * @description: 判断是否是数组
 * @param {*} arr 被判断的元素
 * @return boolean 结果
 */
export function isArray(arr) {
  return Object.prototype.toString.call(arr) === '[object Array]';
}

/**
 * @description: 表单重置
 * @param {string} refName ref名称
 * @return {*}
 */
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields()
  }
}

// 通用下载方法
export function download(fileName) {
  window.location.href = baseURL + '/common/download?fileName=' + encodeURI(fileName) + '&delete=' + true
}

/**
 * @description: 金额中文大写
 * @param {*} price
 * @return {*}
 */
export function chineseDigital(price) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(price)) return '数据非法'
  let unit = '千百拾亿千百拾万千百拾元角分'
  let str = ''
  parseFloat(price) < 0 && (str = '负')
  price += '00'
  var p = price.indexOf('.')
  if (p >= 0) price = price.substring(0, p) + price.substr(p + 1, 2)
  unit = unit.substr(unit.length - n.length)
  for (var i = 0; i < price.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(price.charAt(i)) + unit.charAt(i)
  return str
    .replace(/零(千|百|拾|角)/g, '零')
    .replace(/(零)+/g, '零')
    .replace(/零(万|亿|元)/g, '$1')
    .replace(/(亿)万|壹(拾)/g, '$1$2')
    .replace(/^元零?|零分/g, '')
    .replace(/元$/g, '元整')
}

/**
 * @description: 返回状态颜色
 * @param {*} status 状态
 * @return {string}
 */
export function getColor(status) {
  switch (status) {
    case '待采购处理':
      return '#FA5058'
    case '待发货':
      return '#FFA21D'
    case '已发货':
      return '#15AD3C'
    case '出货完了':
      return '#2C96E7'
    case '上架完了':
      return '#2C96E7'
    case '待拍下':
      return '#FFA21D '
    case '订单取消':
      return '#333333'
    case '购买中':
      return '#FFA21D'
    case '购买完了':
      return '#15AD3C '
    case '待财务付款':
      return '#15AD3C '

  }
}

//   将数组转换为onum个一组
export function changeArr(oarr, onum) {
  const arr = oarr
  const len = arr.length
  let result = []
  const sliceNum = onum // 这个值代表几个一组

  for (let i = 0; i < len / sliceNum; i++) {
    result.push(arr.slice(i * sliceNum, (i + 1) * sliceNum))
  }
  // 补足不足onum个的最后一个数组
  // for(let j = 0; j < (sliceNum - len % sliceNum); j++) {
  //     result[result.length - 1].push({})
  // }

  return result
}

/**
 * @param {Num} status 数字
 * @param {wei} status 位数
 * @return {number}
 */
export function ceil(Num, wei) {
  if (Num == '-') return 0
  let ni = 2
  if (wei) {
    ni = wei
  }
  if (Num && !isNaN(Num)) {
    return Number(Number(Math.round(Num * 10 ** ni) / 10 ** ni).toFixed(ni))
    // return Math.round(Num * 100) / 100
  }
  return Num
}

/**
 * @param {Num} status 数字 日元

 * @return {number}
 */
export function ceilYen(num) {
  if (num && typeof Number(num) !== 'number') {
    return num;
  }
  return Math.round(num);
}
/**
 * 千分位
 * @param {Num} status 数字
 * @return {number}
 */
export function formatNumber(num) {
  // 将数字转换为字符串并分割整数和小数部分
  const parts = num.toString().split('.');
  // 对整数部分添加千分位逗号
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // 返回合并后的结果
  return parts.join('.');
}